import React, { useMemo, useState } from 'react'
import { InputMask } from 'primereact/inputmask'
import { provincialFormatPattern } from "../../utilities/provincialFormatPattern";

const FormatPersonalHealthHumber = ({ personalHealthNumber, setPersonalHealthNumber, personalHealthNumberAttributeValue }) => {
  const maskPattern = useMemo( () => provincialFormatPattern(process.env.REACT_APP_PROVINCE), [process.env.REACT_APP_PROVINCE])

  return (
    <InputMask
      name={personalHealthNumberAttributeValue}
      mask={maskPattern}
      value={personalHealthNumber}
      onChange={(e) => setPersonalHealthNumber(e.target.value)}
      required
    />
  )
}


export default FormatPersonalHealthHumber
